import { useEffect, useState } from "react";
import { Seo } from "../components/Seo";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    api.get(`/blog/${slug}`).then((res) => setPost(res.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="min-h-screen bg-obsidian pt-40 text-center" data-testid="blog-post-not-found">
        <p className="text-zinc-400 font-mono">Article not found.</p>
        <Link to="/blog" className="text-amber-light underline mt-4 inline-block">Back to Insights</Link>
      </div>
    );
  }

  if (!post) return <div className="min-h-screen bg-obsidian pt-40 text-center text-zinc-500 font-mono">Loading...</div>;

  return (
    <div className="min-h-screen bg-obsidian pt-32 pb-24" data-testid="blog-post-page">
      <Seo
        title={`${post.title} | Orion Services LLC`}
        description={post.meta_description}
        image={post.cover_image}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Article",
          headline: post.title,
          description: post.meta_description,
          image: post.cover_image ? [post.cover_image] : undefined,
          datePublished: post.published_at,
          dateModified: post.published_at,
          author: { "@type": "Person", name: post.author },
          publisher: { "@type": "Organization", name: "Orion Services LLC" },
          mainEntityOfPage: typeof window !== "undefined" ? window.location.href : undefined,
        }}
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/blog" className="inline-flex items-center gap-2 text-xs font-mono uppercase text-zinc-500 hover:text-amber-light mb-8">
          <ArrowLeft className="h-3.5 w-3.5" /> Back to Insights
        </Link>
        <span className="text-xs font-mono uppercase tracking-widest text-amber-light">{post.category}</span>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase text-white mt-3 mb-4 leading-tight">{post.title}</h1>
        <div className="text-sm text-zinc-500 mb-8">{post.author} &middot; {post.read_time}</div>
        <div className="aspect-[16/9] overflow-hidden rounded-md border border-amber-500/10 mb-10">
          <img src={post.cover_image} alt={post.title} loading="lazy" className="w-full h-full object-cover" />
        </div>
        <div className="prose prose-invert max-w-none" data-testid="blog-post-content">
          {post.content.split("\n\n").map((para, i) => (
            <p key={i} className="text-base text-zinc-300 leading-relaxed mb-5">{para}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
